<mat-dialog-content class="main col{{ columns }}">
  @if ((loading$ | async) === false) {
    <div>
      @if ((hasVisibleTemplates$ | async) === true) {
        @if (easyEcommerceTemplates$ | async; as easyEcommerceTemplates) {
          @if (
            easyEcommerceTemplates && easyEcommerceTemplates.length > 0 && (showIncludedTemplates$ | async) === true
          ) {
            <div>
              <span class="title">
                {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.ECOMMERCE.TITLE' | translate }}
              </span>
              <span class="subtext">
                <img src="{{ this.starImage }}" alt="" />
                <span
                  [innerHTML]="'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.ECOMMERCE.SUBTITLE' | translate"
                ></span>
              </span>
            </div>
            <mat-grid-list
              class="grid-list"
              [cols]="columns"
              [rowHeight]="rowHeight"
              (window:resize)="onResize($event)"
            >
              <ng-container>
                @for (template of easyEcommerceTemplates; track template) {
                  <mat-grid-tile>
                    <app-template-card
                      calss="template-card"
                      [template]="template"
                      [canEdit]="false"
                      [canDelete]="false"
                      [icon]="this.starImage"
                      [templateSelect]="true"
                      [isStaging]="true"
                      (selected)="selectTemplate($event)"
                    ></app-template-card>
                  </mat-grid-tile>
                }
              </ng-container>
            </mat-grid-list>
          }
        }
        @if (standardTemplates$ | async; as standardTemplates) {
          @if (standardTemplates && standardTemplates.length > 0 && (showIncludedTemplates$ | async) === true) {
            <div>
              <span class="title">
                {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.STANDARD.TITLE' | translate }}
              </span>
              <span class="subtext"></span>
            </div>
            <mat-grid-list
              class="grid-list"
              [cols]="columns"
              [rowHeight]="rowHeight"
              (window:resize)="onResize($event)"
            >
              @for (template of standardTemplates; track template) {
                <mat-grid-tile>
                  <app-template-card
                    [template]="template"
                    [canEdit]="false"
                    [canDelete]="false"
                    [templateSelect]="true"
                    [isStaging]="true"
                    (selected)="selectTemplate($event)"
                  ></app-template-card>
                </mat-grid-tile>
              }
            </mat-grid-list>
          }
        }
        @if (partnerTemplates$ | async; as partnerTemplates) {
          @if (partnerTemplates && partnerTemplates.length > 0) {
            <div>
              <span class="title">
                {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.PARTNER_CREATED.TITLE' | translate }}
              </span>
              <span class="subtext"></span>
            </div>
            <mat-grid-list
              class="grid-list"
              [cols]="columns"
              [rowHeight]="rowHeight"
              (window:resize)="onResize($event)"
            >
              @for (template of partnerTemplates; track template) {
                <mat-grid-tile>
                  <app-template-card
                    [template]="template"
                    [canEdit]="false"
                    [canDelete]="false"
                    [templateSelect]="true"
                    [isStaging]="true"
                    (selected)="selectTemplate($event)"
                  ></app-template-card>
                </mat-grid-tile>
              }
            </mat-grid-list>
          }
        }
        @if (marketingTemplates$ | async; as marketingTemplates) {
          @if (marketingTemplates && marketingTemplates.length > 0 && (showIncludedTemplates$ | async) === true) {
            <mat-grid-list
              class="grid-list"
              [cols]="columns"
              [rowHeight]="rowHeight"
              (window:resize)="onResize($event)"
            >
              @for (template of marketingTemplates; track template) {
                <mat-grid-tile>
                  <app-template-card
                    [template]="template"
                    [canEdit]="false"
                    [canDelete]="false"
                    [templateSelect]="true"
                    [isStaging]="true"
                    (selected)="selectTemplate($event)"
                  ></app-template-card>
                </mat-grid-tile>
              }
            </mat-grid-list>
          }
        }
      }
    </div>
  } @else {
    <mat-spinner class="info-spinner" color="accent" [diameter]="60" [strokeWidth]="8"></mat-spinner>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
